import React from 'react';
import 'whatwg-fetch';
import withAuth from 'src/hoc/withAuth';

const apiDealShow = '/api/deal/show/';

const oriState = {
  dataContacts: undefined,
  interlocutorToAddId: -1,
};

class ModalDealInterlocutor extends React.Component {
  constructor(props) {
    super(props);
    this.state = oriState;

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.linkInterlocutor = this.linkInterlocutor.bind(this);
    this.close = this.close.bind(this);
    this.reset = this.reset.bind(this);
  }

  reset() {
    this.state = oriState;
    this.setState(oriState);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.entityAssociated !== prevProps.entityAssociated) {
      let myContacts = this.props.entityAssociated.customer.contacts.concat(
        this.props.entityAssociated.customer.externalContacts
      );
      let interlocutors = this.props.entityAssociated.interlocutors;
      let contatctsNotInterlocutors = [];
      for (let i = 0; i < myContacts.length; i++) {
        let found = false;
        for (let j = 0; j < interlocutors.length; j++) {
          if (myContacts[i].id === interlocutors[j].id) {
            found = true;
          }
        }
        if (!found) {
          contatctsNotInterlocutors.push(myContacts[i]);
        }
      }
      this.setState({
        dataContacts: contatctsNotInterlocutors,
      });
    }
  }

  render() {
    if (this.props.isOpen === false) return null;

    const { dataContacts } = this.state;

    return (
      <div className='modal myModal'>
        <div className='modal-dialog modal-md'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h4 className='modal-title'>Ajouter interlocuteur</h4>
              <button onClick={this.close} type='button' className='close' data-dismiss='modal' aria-label='Close'>
                <span aria-hidden='true'>&times;</span>
              </button>
            </div>
            <form>
              <div className='modal-body'>
                {this.props.entityAssociated && (
                  <div>
                    <div className='form-group'>
                      <label>Interlocuteur</label>
                      <select
                        name='interlocutorToAddId'
                        value={this.state.interlocutorToAddId}
                        onChange={this.handleInputChange}
                        className='form-control'
                      >
                        <option value={-1}>Sélectionner</option>
                        {dataContacts ? (
                          dataContacts.map((data) => <option value={data.id}>{data.name + ' ' + data.lastname}</option>)
                        ) : (
                          <span>Chargement...</span>
                        )}
                      </select>
                    </div>
                  </div>
                )}
              </div>
              <div className='modal-actions'>
                <button onClick={this.close} type='button' className='btn-link modal-action' data-dismiss='modal'>
                  Annuler
                </button>
                <button
                  onClick={this.handleSubmit}
                  type='button'
                  className='btn-link modal-action'
                  data-dismiss='modal'
                >
                  <strong>Valider</strong>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }

  handleSubmit() {
    if (this.state.interlocutorToAddId !== -1) {
      this.linkInterlocutor(this.props.entityAssociated.id, this.state.interlocutorToAddId);
    }

    this.close();
  }

  linkInterlocutor(dealId, interlocutorId) {
    let graphQL = 'mutation { deal(id:' + dealId + ' interlocutorToAddId:' + interlocutorId + '){interlocutors{ id }}}';

    let queryURL = apiDealShow;
    let data = 'data=' + encodeURIComponent(graphQL);
    console.log(data);
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        method: 'POST',
        body: data,
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['data']['deal']['interlocutors'].length !== this.props.entityAssociated.interlocutors.length) {
            this.props.openToast(true, "L'interlocuteur a bien été ajouté.");
            this.props.onLinkResult();
          } else {
            this.props.openToast(false, "Erreur lors de l'ajout. Veuillez réessayer.");
          }
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch UPDATE deal entity');
        }.bind(this)
      );
  }

  close() {
    this.reset();
    if (this.props.onClose) {
      this.props.onClose();
    }
  }
}

export default withAuth(ModalDealInterlocutor);
